import { Division, EmptyState, Icons, Paragraph } from "@ir/ui";

export const MasterDataLandingPage = () => (
  <Division className="master-data-landing">
    <EmptyState
      icon={Icons.Rows01}
      title="Select an organization and brand"
      description="Choose an Org/Brand above to view and manage Master Data for that brand."
    />
    <Paragraph className="text-grey-500 text-center mt-2">
      The Master Data submenu becomes available after a brand is selected.
    </Paragraph>
  </Division>
);
